import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import * as _ from 'lodash';

/**
 * 点一下会改变的按键
 */
@Component({
})
export default class SelectButton extends Vue {
  @Prop()
  public arr: Array<{
    value: number;
    text: string;
  }>;

  @Prop({ default: 0 })
  public value: number;

  public handleChange() {
    let currentIndex = _.findIndex(this.arr,
      r => r.value === this.value);

    currentIndex = (currentIndex + 1) % (this.arr.length);
    this.$emit('input', this.arr[currentIndex].value);
  }
  public get current() {
    const currentIndex = _.findIndex(this.arr,
      r => r.value === this.value);

    return this.arr[currentIndex];
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/components/SelectButton/SelectButton.ts